import { memo } from 'react';
import { useGoogleTranslate } from '@/hooks/useGoogleTranslator.ts';

const GTranslateComponent = () => {
  useGoogleTranslate({
    selectId: 'langSelect',
    translateElementId: 'google_translate_element'
  });

  return (
    <div>
      <div className="lang-sidebar notranslate flex items-center gap-5">
        <select
          id="langSelect"
          className="notranslate px-2 py-1 rounded text-white bg-[var(--mantine-primary-color-filled)] textnewstyleData"
        />
      </div>
      <div id="google_translate_element" style={{ display: 'none' }}></div>
    </div>
  );
};

const GTranslate = memo(GTranslateComponent);

export default GTranslate;
